import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createDaycare, createModules, fetchDaycare, fetchDaycareById, fetchModules, fetchPaymentHistory, removeDaycare, removeModules, resendPaymentLink, updateDaycare, updateDaycareStatus, updateModules } from "../../service/api";


export const getPaymentHistory = createAsyncThunk(
    "payment/getAll",
    async (params, { rejectWithValue }) => {
        try {
            const response = await fetchPaymentHistory(params)
            console.log("fetch payment", response)
            return response.data.data
        } catch (error) {
            return rejectWithValue(err.response?.data || err.message)

        }
    }
)

export const actionResendPaymentLink = createAsyncThunk(
    "payment/resend",
    async (formValue, { rejectWithValue }) => {
        try {
            const response = await resendPaymentLink(formValue)
            if (response.status === 201) {
                console.log("add resent", response)
            }
        } catch (error) {
            return rejectWithValue(error.response || error)
        }
    }
)

const paymentSlice = createSlice({
    name: "payment",
    initialState: {
        paymentHistory: [],
       
        isLoading: false,
        actionLoader: false,
        error: null,
        totalPage: 0,
        current: 1,
        date: null,
        limit: 10,
        searchParams: ""
    },
    reducers: {
        setPagination: (state, action) => {
            state.current = action.payload;
        },
        setSearchParams: (state, action) => {
            state.searchParams = action.payload;
        },
        setDateKeyFilter: (state, action) => {
            state.date = action.payload
        }
    },

    extraReducers: (builder) => {
        builder
            .addCase(getPaymentHistory.pending, (state) => {
                state.isLoading = true,
                    state.error = null
            })
            .addCase(getPaymentHistory.fulfilled, (state, action) => {
                state.isLoading = false;
                state.paymentHistory = action.payload.data;
                state.totalPage = action.payload.totalPage
            })
            .addCase(getPaymentHistory.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload
            })

            // POST
            .addCase(actionResendPaymentLink.pending, (state, action) => {
                state.actionLoader = true;
            })
            .addCase(actionResendPaymentLink.fulfilled, (state, action) => {
                state.actionLoader = false;
            })
            .addCase(actionResendPaymentLink.rejected, (state, action) => {
                state.actionLoader = false;
                state.error = action.payload;
            })
    }
})

export const { setSearchParams, setPagination, setDateKeyFilter } = paymentSlice.actions;

export default paymentSlice.reducer;